export const textsEs = {
  privacyPolicy: 'Política de Privacidad',
  termsOfUse: 'Terminos de uso',
  mainHeader: `Herramientas financieras: calculadora 12C, préstamo,
   amortización de financiaciones, inversiones, interés compuesto`,
};
